module.exports = __webpack_public_path__ + "media/images/menu/news-63749658d2382489f8b48661908d65d9.svg";